import { z } from "zod";
import { httpsUrlSchema } from "@common/schemas/shared.schema";

// Public pay-page states. `payable` is the only state that carries a
// `checkoutUrl` for the SPA to redirect to; every other state renders a small
// status screen. Unknown / invalid tokens are a 404, not a state here.
export enum NativeInvoicePayStatus {
    PAYABLE = "payable",
    PAID = "paid",
    PROCESSING = "processing",
    VOID = "void",
    UNCOLLECTABLE = "uncollectable",
    COLLECT_OFF = "collect_off",
    STRIPE_NOT_READY = "stripe_not_ready",
    AMOUNT_DUE_ZERO = "amount_due_zero",
}

// Deliberately minimal: no line items and no customer PII beyond the invoice
// number, entity display name, currency, and amount due.
export const nativeInvoicePayResponseSchema = z.object({
    status: z.nativeEnum(NativeInvoicePayStatus),
    // Server-controlled hosted Checkout URL. The SPA calls
    // `window.location.assign(checkoutUrl)`, so this is defense-in-depth should
    // the backend source ever change.
    checkoutUrl: httpsUrlSchema.nullable(),
    invoiceNumber: z.string().nullable(),
    entityName: z.string(),
    amountDue: z.number(),
    currency: z.string(),
});

export type NativeInvoicePayResponse = z.infer<
    typeof nativeInvoicePayResponseSchema
>;
